import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Value } from '@/model/common';
import { WithdrawalReceiver } from '@/model/withdrawal/types';

import SubjectItem from '../SubjectItem';

interface ReceiverItemProps {
  'data-test'?: string;
  value?: Value<WithdrawalReceiver>;
  shortPhoneMask?: boolean;
  readonly?: boolean;
  onChange?: (value: string) => Promise<void> | void;
}

const ReceiverItem: React.FC<ReceiverItemProps> = (props) => (
  <SubjectItem
    {...props}
    messages={{
      label: <FormattedMessage id="withdrawal.fields.receiver.label" />,
      phoneLabel: <FormattedMessage id="withdrawal.fields.receiver.phone.label" />,
      phoneError: <FormattedMessage id="withdrawal.fields.receiver.phone.error" />,
    }}
  />
);

export default ReceiverItem;
